import { buildBillingEndpoints } from "../../../../core/store/reduxApi/billing";
import { reduxApiSlice } from "./index";

export type {
  BillingInterval,
  PlanSummaryResponse,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
} from "../../../../core/store/reduxApi/billing";

const extendedApi = reduxApiSlice.injectEndpoints({
  endpoints: buildBillingEndpoints,
  overrideExisting: false,
});

export const { useGetPlanSummaryQuery, useUpdateSubscriptionMutation } =
  extendedApi;
